export enum AssignmentSource {
	CreatedInTms = 0,
	Outsourcing = 1,
    ReceivedByIntermediary = 2
}

export const AssignmentSourceOptions = [
    {
        label: "core.assignment_source.created_in_tms",
        value: AssignmentSource.CreatedInTms
    },
    {
        label: "core.assignment_source.outsourcing",
        value: AssignmentSource.Outsourcing
    },
    {
        label: "core.assignment_source.received_by_intermediary",
        value: AssignmentSource.ReceivedByIntermediary
    }
]
